import styled from "styled-components";

export const OverlayContainer = styled.div<{ height: string, display: string }>`
    height: ${(props) => props.height == "max" ? "100%" : props.height + "px"};
    width: 100%;
    grid-row-start: 1;
    grid-column-start: 1;
    padding: 0px 0px;
    z-index: 9;
    background-color: #083454;
    display: ${(props) => props.display};
    position: absolute;
    top: 0;
    left: 0;
    opacity: 90%;
    vertical-align: middle;
    justify-content: center;
    align-items: center;

    &:hover {
        display: flex;
    }
`